import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

export const TagView = memo(
  ({
    value,
    style,
    textStyle,
  }: {
    value?: string;
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          background-color: rgba(0, 119, 225, 0.1);
          border-width: 1px;
          border-radius: ${rpx(3)}px;
          justify-content: center;
          align-items: center;
          border-color: rgba(0, 119, 225, 0.45);
          padding: 0 ${rpx(5)}px;
        `}
        style={style}
      >
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Light};
            font-size: ${rpx(11)}px;
          `}
          style={textStyle}
        >
          {value}
        </Text>
      </View>
    );
  },
);
